import { useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import {
  threadActivityQuery,
  ThreadActivityLog,
} from "@/app/Threads/GraphQL/threadActivityQuery";
import { ThreadsQueryThread } from "@/app/Threads/GraphQL/threadQueries";
import { threadTimelineEvents } from "@/app/Threads/constants/threadTimelineEvents";
import {
  ModelType,
  QueryActivityLogsOrderByColumn,
  QueryActivityLogsWhereColumn,
  SortOrder,
  SqlOperator,
} from "@/gql/graphql";

function subjectsOf(thread: ThreadsQueryThread) {
  const workOrder =
    thread.threadable?.__typename === "WorkOrder" ? thread.threadable : null;

  if (!workOrder) {
    return [];
  }

  const assignmentIds = workOrder.assignments.map((assignment) =>
    String(assignment.id),
  );

  return [
    {
      AND: [
        {
          column: QueryActivityLogsWhereColumn.SubjectType,
          value: ModelType.WorkOrder,
        },
        {
          column: QueryActivityLogsWhereColumn.SubjectId,
          value: String(workOrder.id),
        },
      ],
    },
    ...(assignmentIds.length > 0
      ? [
          {
            AND: [
              {
                column: QueryActivityLogsWhereColumn.SubjectType,
                value: ModelType.WorkOrderAssignment,
              },
              {
                column: QueryActivityLogsWhereColumn.SubjectId,
                operator: SqlOperator.In,
                value: assignmentIds,
              },
            ],
          },
        ]
      : []),
  ];
}

/**
 * The work order's milestones and its assignments', read through the activity
 * log's own rules - so a reader sees here exactly what the Activity tab would
 * show them, and nothing the thread would otherwise widen.
 */
export function useThreadActivity(
  thread: ThreadsQueryThread | null | undefined,
  enabled: boolean,
): ThreadActivityLog[] {
  const subjects = thread ? subjectsOf(thread) : [];

  const { data } = useGqlQuery(
    threadActivityQuery,
    {
      first: 200,
      where: {
        AND: [
          {
            column: QueryActivityLogsWhereColumn.Event,
            operator: SqlOperator.In,
            value: threadTimelineEvents,
          },
          { OR: subjects },
        ],
      },
      orderBy: [
        {
          column: QueryActivityLogsOrderByColumn.CreatedAt,
          order: SortOrder.Desc,
        },
      ],
    },
    { enabled: enabled && subjects.length > 0 },
  );

  return enabled ? (data?.activityLogs?.data ?? []) : [];
}
